<template>
  <div class="p-2 sm:p-4 text-lexend overflow-x-hidden min-h-screen bg-gray-50 dark:bg-gray-900/50">
    <!-- Encabezado -->
    <div class="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-3 sm:gap-4 mb-3 sm:mb-5 mt-1">
      <div class="animate-fadeIn w-full sm:w-auto">
        <div class="flex items-center gap-2 mb-1">
          <div class="w-8 h-1 bg-indigo-600 rounded-full"></div>
          <span class="text-[10px] sm:text-xs font-black text-indigo-600 tracking-widest">Panel de Control</span>
        </div>
        <h1 class="text-xl sm:text-3xl font-black text-gray-900 dark:text-white tracking-tight flex items-center flex-wrap gap-2">
          Crear Nueva Venta
          <span class="px-2 sm:px-3 py-0.5 bg-green-100 dark:bg-green-900/40 text-green-600 dark:text-green-300 text-xs sm:text-sm font-black rounded-lg border border-green-200 dark:border-green-800">
            Nuevo
          </span>
        </h1>
        <p class="text-[10px] sm:text-xs text-gray-500 dark:text-gray-400 mt-0.5">SYSTEM JJ - Sistema de Ventas</p>
      </div>
      
      <button @click="volverAListado" class="px-3 sm:px-6 py-2 sm:py-3 bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-700 rounded-xl text-gray-700 dark:text-gray-300 hover:bg-gray-50 dark:hover:bg-gray-700 transition-all duration-200 shadow-sm hover:shadow flex items-center gap-2 w-full sm:w-auto justify-center">
        <Icon icon="mdi:arrow-left" class="text-base sm:text-lg" />
        <span class="hidden sm:inline">Volver al listado</span>
        <span class="sm:hidden">Volver</span>
      </button>
    </div>

    <!-- Formulario en dos columnas -->
    <div class="grid grid-cols-1 lg:grid-cols-2 gap-3 sm:gap-4">
      <!-- Columna izquierda -->
      <div class="space-y-3 sm:space-y-4">
        <!-- Tarjeta de Cliente -->
        <div class="bg-white dark:bg-gray-800 rounded-2xl shadow-md border border-gray-200 dark:border-gray-700 overflow-visible relative z-20">
          <div class="bg-gradient-to-r from-blue-50 to-indigo-50 dark:from-gray-800 dark:to-gray-800 px-3 sm:px-4 py-2 border-b border-gray-100 dark:border-gray-700 rounded-t-2xl">
            <h2 class="text-sm sm:text-lg font-semibold text-gray-800 dark:text-white flex items-center">
              <div class="p-1.5 sm:p-2 bg-blue-100 dark:bg-blue-900/30 rounded-lg mr-2 sm:mr-3">
                <Icon icon="mdi:account" class="text-blue-600 dark:text-blue-400 text-base sm:text-xl" />
              </div>
              Información del Cliente
              <span class="ml-2 text-[8px] sm:text-[10px] bg-red-100 text-red-600 dark:bg-red-900/30 dark:text-red-400 px-1.5 sm:px-2 py-0.5 rounded-full font-bold">* Requerido</span>
            </h2>
          </div>
          <div class="p-3 sm:p-4">
            <div class="flex space-x-1 bg-gray-100 dark:bg-gray-700 p-1 rounded-xl mb-3 sm:mb-4">
              <button @click="modoCliente = 'buscar'" :class="['flex-1 px-2 sm:px-4 py-1.5 sm:py-2.5 text-[10px] sm:text-sm font-medium rounded-lg transition-all duration-200', modoCliente === 'buscar' ? 'bg-white dark:bg-gray-800 text-blue-600 dark:text-blue-400 shadow-sm' : 'text-gray-600 dark:text-gray-400 hover:text-gray-900 dark:hover:text-gray-200']">
                <Icon icon="mdi:magnify" class="inline mr-1 text-sm" /> Buscar
              </button>
              <button @click="modoCliente = 'crear'" :class="['flex-1 px-2 sm:px-4 py-1.5 sm:py-2.5 text-[10px] sm:text-sm font-medium rounded-lg transition-all duration-200', modoCliente === 'crear' ? 'bg-white dark:bg-gray-800 text-green-600 dark:text-green-400 shadow-sm' : 'text-gray-600 dark:text-gray-400 hover:text-gray-900 dark:hover:text-gray-200']">
                <Icon icon="mdi:account-plus" class="inline mr-1 text-sm" /> Nuevo
              </button>
            </div>

            <!-- Modo Buscar Cliente -->
            <div v-if="modoCliente === 'buscar'" class="relative">
              <label class="block text-[10px] sm:text-sm font-medium text-gray-700 dark:text-gray-300 mb-1 sm:mb-2">Buscar Cliente Existente</label>
              <div class="relative">
                <Icon icon="mdi:magnify" class="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 text-sm sm:text-base" />
                <input v-model="buscarCliente" type="text" placeholder="Nombre, documento, teléfono o email..." class="w-full pl-9 sm:pl-12 pr-3 sm:pr-4 py-1.5 sm:py-2 border border-gray-200 dark:border-gray-600 rounded-xl bg-white dark:bg-gray-700 focus:ring-2 focus:ring-blue-500 text-xs sm:text-sm" @input="debounceBuscarClientes" @focus="mostrarClientesSiHay" />
              </div>
              
              <div v-if="mostrarListaClientes && clientesEncontrados.length > 0" class="absolute mt-2 w-full bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-700 rounded-xl shadow-2xl max-h-60 sm:max-h-72 overflow-y-auto z-50">
                <div v-for="cliente in clientesEncontrados" :key="cliente.idCliente" @click="seleccionarCliente(cliente)" class="p-2 sm:p-4 hover:bg-gray-50 dark:hover:bg-gray-700 cursor-pointer border-b border-gray-100 dark:border-gray-700 last:border-b-0">
                  <div class="flex items-start gap-2 sm:gap-3">
                    <div class="p-1.5 sm:p-2 bg-blue-100 dark:bg-blue-900/30 rounded-lg">
                      <Icon icon="mdi:account-circle" class="text-blue-600 dark:text-blue-400 text-base sm:text-xl" />
                    </div>
                    <div class="flex-1 min-w-0">
                      <div class="flex flex-col sm:flex-row sm:justify-between sm:items-start gap-1">
                        <div>
                          <p class="font-semibold text-gray-800 dark:text-white text-xs sm:text-sm">{{ cliente.nombre }} {{ cliente.apellido }}</p>
                          <p class="text-[10px] sm:text-sm text-gray-600 dark:text-gray-400 mt-0.5">{{ formatearTipoDocumento(cliente.tipoDocumento) }}: <span class="font-mono">{{ cliente.documento }}</span></p>
                          <div class="flex flex-wrap items-center gap-2 sm:gap-3 mt-1 text-[9px] sm:text-xs text-gray-500 dark:text-gray-400">
                            <span v-if="cliente.telefono" class="flex items-center"><Icon icon="mdi:phone" class="mr-0.5 sm:mr-1 text-xs" />{{ cliente.telefono }}</span>
                            <span v-if="cliente.email" class="flex items-center"><Icon icon="mdi:email" class="mr-0.5 sm:mr-1 text-xs" />{{ cliente.email }}</span>
                          </div>
                        </div>
                        <Icon v-if="form.idCliente === cliente.idCliente" icon="mdi:check-circle" class="text-green-500 text-lg sm:text-2xl flex-shrink-0" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              
              <div v-if="buscarCliente && buscarCliente.trim().length >= 2 && !cargandoClientes && clientesEncontrados.length === 0" class="absolute mt-2 w-full p-4 sm:p-6 text-center bg-gray-50 dark:bg-gray-800/50 rounded-xl border border-gray-200 dark:border-gray-700 z-50">
                <Icon icon="mdi:account-search" class="text-3xl sm:text-4xl text-gray-400 mx-auto mb-2" />
                <p class="text-xs sm:text-sm text-gray-600 dark:text-gray-400 mb-2 sm:mb-3">No encontramos "{{ buscarCliente }}"</p>
                <button @click="modoCliente = 'crear'" class="px-3 sm:px-4 py-1.5 sm:py-2 bg-green-600 text-white text-[10px] sm:text-sm rounded-lg hover:bg-green-700 transition-colors inline-flex items-center gap-1 sm:gap-2">
                  <Icon icon="mdi:account-plus" />Crear cliente
                </button>
              </div>
              
              <div v-if="cargandoClientes" class="absolute mt-2 w-full p-3 sm:p-4 text-center bg-white dark:bg-gray-800 rounded-xl border border-gray-200 dark:border-gray-700 shadow-2xl z-50">
                <div class="inline-block animate-spin rounded-full h-4 sm:h-5 w-4 sm:w-5 border-2 border-blue-500 border-t-transparent"></div>
                <p class="text-[10px] sm:text-sm text-gray-500 dark:text-gray-400 mt-1 sm:mt-2">Buscando clientes...</p>
              </div>
            </div>

            <!-- Modo Crear Cliente -->
            <div v-if="modoCliente === 'crear'">
              <form @submit.prevent="guardarNuevoCliente" class="space-y-3 sm:space-y-4">
                <div class="grid grid-cols-2 gap-2 sm:gap-3">
                  <div>
                    <label class="block text-[9px] sm:text-xs font-medium text-gray-700 dark:text-gray-300 mb-0.5 sm:mb-1">Tipo Doc. <span class="text-red-500">*</span></label>
                    <select v-model="nuevoCliente.tipoDocumento" class="w-full px-2 sm:px-3 py-1.5 sm:py-2 border border-gray-200 dark:border-gray-600 rounded-xl bg-white dark:bg-gray-700 focus:ring-2 focus:ring-blue-500 text-[10px] sm:text-sm">
                      <option value="">Seleccionar...</option>
                      <option value="cedula">Cédula</option>
                      <option value="rif">RIF</option>
                      <option value="pasaporte">Pasaporte</option>
                      <option value="identificacion_extranjera">Extranjera</option>
                    </select>
                  </div>
                  <div>
                    <label class="block text-[9px] sm:text-xs font-medium text-gray-700 dark:text-gray-300 mb-0.5 sm:mb-1">N° Documento <span class="text-red-500">*</span></label>
                    <input v-model="nuevoCliente.documento" type="text" :placeholder="getPlaceholderDocumento(nuevoCliente.tipoDocumento)" class="w-full px-2 sm:px-3 py-1.5 sm:py-2 border border-gray-200 dark:border-gray-600 rounded-xl bg-white dark:bg-gray-700 focus:ring-2 focus:ring-blue-500 text-[10px] sm:text-sm" @blur="formatearDocumentoInput" />
                  </div>
                  <div>
                    <label class="block text-[9px] sm:text-xs font-medium text-gray-700 dark:text-gray-300 mb-0.5 sm:mb-1">Nombre <span class="text-red-500">*</span></label>
                    <input v-model="nuevoCliente.nombre" type="text" placeholder="Ej: Juan" class="w-full px-2 sm:px-3 py-1.5 sm:py-2 border border-gray-200 dark:border-gray-600 rounded-xl bg-white dark:bg-gray-700 focus:ring-2 focus:ring-blue-500 text-[10px] sm:text-sm" />
                  </div>
                  <div>
                    <label class="block text-[9px] sm:text-xs font-medium text-gray-700 dark:text-gray-300 mb-0.5 sm:mb-1">Apellido</label>
                    <input v-model="nuevoCliente.apellido" type="text" placeholder="Ej: Rodríguez" class="w-full px-2 sm:px-3 py-1.5 sm:py-2 border border-gray-200 dark:border-gray-600 rounded-xl bg-white dark:bg-gray-700 focus:ring-2 focus:ring-blue-500 text-[10px] sm:text-sm" />
                  </div>
                  <div>
                    <label class="block text-[9px] sm:text-xs font-medium text-gray-700 dark:text-gray-300 mb-0.5 sm:mb-1">Teléfono</label>
                    <input v-model="nuevoCliente.telefono" type="text" placeholder="0414-7470715" class="w-full px-2 sm:px-3 py-1.5 sm:py-2 border border-gray-200 dark:border-gray-600 rounded-xl bg-white dark:bg-gray-700 focus:ring-2 focus:ring-blue-500 text-[10px] sm:text-sm" @blur="formatearTelefonoInput" />
                  </div>
                  <div>
                    <label class="block text-[9px] sm:text-xs font-medium text-gray-700 dark:text-gray-300 mb-0.5 sm:mb-1">Email</label>
                    <input v-model="nuevoCliente.email" type="email" placeholder="ejemplo@email.com" class="w-full px-2 sm:px-3 py-1.5 sm:py-2 border border-gray-200 dark:border-gray-600 rounded-xl bg-white dark:bg-gray-700 focus:ring-2 focus:ring-blue-500 text-[10px] sm:text-sm" />
                  </div>
                  <div class="col-span-2">
                    <label class="block text-[9px] sm:text-xs font-medium text-gray-700 dark:text-gray-300 mb-0.5 sm:mb-1">Dirección</label>
                    <textarea v-model="nuevoCliente.direccion" rows="1" placeholder="Dirección completa..." class="w-full px-2 sm:px-3 py-1.5 sm:py-2 border border-gray-200 dark:border-gray-600 rounded-xl bg-white dark:bg-gray-700 focus:ring-2 focus:ring-blue-500 resize-none text-[10px] sm:text-sm"></textarea>
                  </div>
                </div>
                <div class="flex flex-col sm:flex-row gap-2 sm:gap-3 pt-1 sm:pt-2">
                  <button type="submit" :disabled="!puedeGuardarCliente || guardandoCliente" :class="['flex-1 px-3 sm:px-4 py-1.5 sm:py-2 rounded-xl transition-all duration-200 flex items-center justify-center gap-1 sm:gap-2 font-medium text-[10px] sm:text-sm', puedeGuardarCliente && !guardandoCliente ? 'bg-gradient-to-r from-green-600 to-emerald-600 text-white hover:from-green-700 hover:to-emerald-700 shadow-md hover:shadow-lg' : 'bg-gray-200 dark:bg-gray-700 text-gray-500 dark:text-gray-400 cursor-not-allowed']">
                    <Icon v-if="guardandoCliente" icon="mdi:loading" class="animate-spin text-base sm:text-lg" />
                    <Icon v-else icon="mdi:account-plus" class="text-base sm:text-lg" />
                    {{ guardandoCliente ? 'Guardando...' : 'Guardar y Seleccionar' }}
                  </button>
                  <button type="button" @click="modoCliente = 'buscar'" class="flex-1 px-3 sm:px-4 py-1.5 sm:py-2 border border-gray-200 dark:border-gray-600 text-gray-700 dark:text-gray-300 rounded-xl hover:bg-gray-50 dark:hover:bg-gray-700 transition-all duration-200 text-[10px] sm:text-sm">Cancelar</button>
                </div>
              </form>
            </div>
            
            <!-- Cliente Seleccionado -->
            <div v-if="clienteSeleccionado" class="mt-4 sm:mt-6 p-3 sm:p-5 bg-gradient-to-r from-green-50 to-emerald-50 dark:from-gray-800 dark:to-gray-800 rounded-xl border border-green-200 dark:border-green-800/50">
              <div class="flex items-start gap-2 sm:gap-3">
                <div class="p-1.5 sm:p-2 bg-green-100 dark:bg-green-900/30 rounded-lg">
                  <Icon icon="mdi:account-check" class="text-green-600 dark:text-green-400 text-xl sm:text-2xl" />
                </div>
                <div class="flex-1 min-w-0">
                  <div class="flex flex-col sm:flex-row sm:justify-between sm:items-start gap-1">
                    <div>
                      <p class="font-semibold text-gray-800 dark:text-white text-sm sm:text-lg">{{ clienteSeleccionado.nombre }} {{ clienteSeleccionado.apellido }}</p>
                      <p class="text-[10px] sm:text-sm text-gray-600 dark:text-gray-400 mt-0.5">{{ formatearTipoDocumento(clienteSeleccionado.tipoDocumento) }}: <span class="font-mono">{{ clienteSeleccionado.documento }}</span></p>
                      <div class="flex flex-wrap gap-2 sm:gap-3 mt-1 text-[10px] sm:text-sm text-gray-600 dark:text-gray-400">
                        <span v-if="clienteSeleccionado.telefono" class="flex items-center"><Icon icon="mdi:phone" class="mr-0.5 sm:mr-1 text-gray-400" />{{ clienteSeleccionado.telefono }}</span>
                        <span v-if="clienteSeleccionado.email" class="flex items-center"><Icon icon="mdi:email" class="mr-0.5 sm:mr-1 text-gray-400" />{{ clienteSeleccionado.email }}</span>
                      </div>
                      <p v-if="clienteSeleccionado.direccion" class="text-[10px] sm:text-sm text-gray-500 dark:text-gray-400 mt-1 sm:mt-2 flex items-start"><Icon icon="mdi:map-marker" class="mr-0.5 sm:mr-1 mt-0.5 text-gray-400" />{{ clienteSeleccionado.direccion }}</p>
                    </div>
                    <button @click="deseleccionarCliente" class="p-1.5 sm:p-2 text-gray-400 hover:text-gray-600 dark:text-gray-500 dark:hover:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-700 rounded-lg transition-all duration-200 self-start" title="Cambiar cliente">
                      <Icon icon="mdi:close" class="text-lg sm:text-xl" />
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Información de la Venta -->
        <div class="bg-white dark:bg-gray-800 rounded-2xl shadow-md border border-gray-200 dark:border-gray-700 overflow-hidden">
          <div class="bg-gradient-to-r from-green-50 to-emerald-50 dark:from-gray-800 dark:to-gray-800 px-3 sm:px-4 py-2 border-b border-gray-100 dark:border-gray-700">
            <h2 class="text-sm sm:text-lg font-semibold text-gray-800 dark:text-white flex items-center">
              <div class="p-1.5 sm:p-2 bg-green-100 dark:bg-green-900/30 rounded-lg mr-2 sm:mr-3">
                <Icon icon="mdi:cart" class="text-green-600 dark:text-green-400 text-base sm:text-xl" />
              </div>
              Información de la Venta
            </h2>
          </div>
          <div class="p-3 sm:p-4 space-y-2 sm:space-y-3">
            <div>
              <label class="block text-[10px] sm:text-sm font-medium text-gray-700 dark:text-gray-300 mb-1 sm:mb-2">Número de Factura</label>
              <div class="relative">
                <Icon icon="mdi:tag" class="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 text-sm sm:text-base" />
                <input v-model="form.numero_factura" type="text" readonly class="w-full pl-9 sm:pl-12 pr-3 sm:pr-4 py-1.5 sm:py-2 border border-gray-200 dark:border-gray-600 rounded-xl bg-gray-50 dark:bg-gray-700/50 text-gray-600 dark:text-gray-400 cursor-not-allowed font-mono text-[10px] sm:text-sm" />
              </div>
            </div>
            <div>
              <label class="block text-[10px] sm:text-sm font-medium text-gray-700 dark:text-gray-300 mb-1 sm:mb-2">Estado</label>
              <div class="relative">
                <Icon icon="mdi:check-circle" class="absolute left-3 top-1/2 transform -translate-y-1/2 text-green-500 text-sm sm:text-base" />
                <input value="Completada" type="text" readonly class="w-full pl-9 sm:pl-12 pr-3 sm:pr-4 py-1.5 sm:py-2 border border-gray-200 dark:border-gray-600 rounded-xl bg-gray-50 dark:bg-gray-700/50 cursor-not-allowed font-medium text-green-600 dark:text-green-400 text-[10px] sm:text-sm" />
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Columna derecha -->
      <div class="space-y-3 sm:space-y-4">
        <!-- Productos -->
        <div class="bg-white dark:bg-gray-800 rounded-2xl shadow-md border border-gray-200 dark:border-gray-700 overflow-hidden">
          <div class="bg-gradient-to-r from-orange-50 to-amber-50 dark:from-gray-800 dark:to-gray-800 px-3 sm:px-4 py-2 sm:py-3 border-b border-gray-100 dark:border-gray-700">
            <div class="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-2">
              <h2 class="text-sm sm:text-lg font-semibold text-gray-800 dark:text-white flex items-center">
                <div class="p-1.5 sm:p-2 bg-orange-100 dark:bg-orange-900/30 rounded-lg mr-2 sm:mr-3">
                  <Icon icon="mdi:package-variant" class="text-orange-600 dark:text-orange-400 text-base sm:text-xl" />
                </div>
                Productos
              </h2>
              <button @click="mostrarModalProductos" :disabled="!clienteSeleccionado" :class="['px-3 sm:px-4 py-1.5 sm:py-2 rounded-xl transition-all duration-200 flex items-center gap-1 sm:gap-2 text-[10px] sm:text-sm font-medium w-full sm:w-auto justify-center', clienteSeleccionado ? 'bg-gradient-to-r from-orange-600 to-amber-600 text-white hover:from-orange-700 hover:to-amber-700 shadow-md hover:shadow-lg' : 'bg-gray-200 dark:bg-gray-700 text-gray-500 dark:text-gray-400 cursor-not-allowed']">
                <Icon icon="mdi:plus" class="text-base sm:text-lg" /> Agregar
              </button>
            </div>
          </div>
          <div class="p-3 sm:p-4">
            <div class="mb-3 sm:mb-4">
              <div class="relative">
                <Icon icon="mdi:barcode-scan" class="absolute left-3 top-1/2 transform -translate-y-1/2 text-blue-500 text-lg sm:text-xl" />
                <input 
                  ref="lectorVentaInput"
                  v-model="codigoEscaneadoVenta"
                  type="text"
                  placeholder="Escanea el código del producto..."
                  @keydown.enter="buscarProductoPorCodigoVenta"
                  class="w-full pl-10 sm:pl-12 pr-3 sm:pr-4 py-2 sm:py-3 bg-blue-50 dark:bg-blue-900/20 border-2 border-blue-300 dark:border-blue-700 rounded-xl text-sm focus:ring-2 focus:ring-blue-500/20 focus:border-blue-500 transition-all outline-none"
                  :disabled="buscandoProductoVenta || !clienteSeleccionado"
                  autofocus
                />
                <div v-if="buscandoProductoVenta" class="absolute right-3 top-1/2 transform -translate-y-1/2">
                  <div class="w-4 h-4 sm:w-5 sm:h-5 border-2 border-blue-500 border-t-transparent rounded-full animate-spin"></div>
                </div>
              </div>
              
              <div v-if="productoEncontradoVenta" class="mt-2 p-2 sm:p-3 bg-green-50 dark:bg-green-900/20 rounded-xl border border-green-200 dark:border-green-800 flex items-start gap-2 sm:gap-3">
                <div class="w-10 h-10 sm:w-14 sm:h-14 rounded-lg overflow-hidden bg-white flex-shrink-0 border border-gray-200">
                  <img 
                    v-if="getImageUrl(productoEncontradoVenta.imagen)" 
                    :src="getImageUrl(productoEncontradoVenta.imagen)" 
                    :alt="productoEncontradoVenta.nombre"
                    class="w-full h-full object-cover"
                    @error="handleImageError"
                  />
                  <div v-else class="w-full h-full flex items-center justify-center text-gray-300">
                    <Icon icon="mdi:package-variant" class="text-2xl sm:text-3xl" />
                  </div>
                </div>
                <div class="flex-1 min-w-0">
                  <div class="flex justify-between items-start">
                    <div>
                      <p class="font-semibold text-gray-800 dark:text-white text-xs sm:text-sm">{{ productoEncontradoVenta.nombre }}</p>
                      <p class="text-[8px] sm:text-xs text-gray-500 dark:text-gray-400">Código: {{ productoEncontradoVenta.codigo }}</p>
                      <p class="text-[8px] sm:text-xs text-gray-500 dark:text-gray-400">Stock: {{ productoEncontradoVenta.stock || 0 }} | Precio: ${{ (productoEncontradoVenta.precio_venta_usd || 0).toFixed(2) }}</p>
                    </div>
                    <div class="flex gap-1">
                      <button @click="agregarProductoDesdeLector(productoEncontradoVenta)" class="px-2 sm:px-3 py-1 bg-green-600 text-white rounded-lg text-[8px] sm:text-xs hover:bg-green-700 transition-all flex items-center gap-0.5 sm:gap-1">
                        <Icon icon="mdi:plus" class="text-xs sm:text-sm" /> Agregar
                      </button>
                      <button @click="productoEncontradoVenta = null" class="p-1 text-gray-400 hover:text-gray-600 dark:hover:text-gray-300">
                        <Icon icon="mdi:close" class="text-xs sm:text-sm" />
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              
              <div v-if="busquedaFallidaVenta" class="mt-2 p-2 sm:p-3 bg-red-50 dark:bg-red-900/20 rounded-xl border border-red-200 dark:border-red-800 text-center">
                <p class="text-red-600 dark:text-red-400 text-xs sm:text-sm">Producto no encontrado: "{{ codigoEscaneadoVenta }}"</p>
                <button @click="busquedaFallidaVenta = false; codigoEscaneadoVenta = ''" class="mt-1 text-[10px] sm:text-xs text-gray-500 hover:text-gray-700 dark:text-gray-400 dark:hover:text-gray-200">Cerrar</button>
              </div>
            </div>
            
            <div v-if="!clienteSeleccionado" class="mb-3 sm:mb-4 p-3 sm:p-4 bg-gray-100 dark:bg-gray-700/50 rounded-xl border border-gray-200 dark:border-gray-600">
              <div class="flex items-center gap-2 sm:gap-3 text-gray-600 dark:text-gray-400">
                <Icon icon="mdi:alert-circle" class="text-xl sm:text-2xl text-gray-400" />
                <p class="text-[10px] sm:text-sm">Selecciona un cliente para agregar productos</p>
              </div>
            </div>
            
            <div v-if="productosSeleccionados.length > 0" class="space-y-2 sm:space-y-3 max-h-80 sm:max-h-96 overflow-y-auto pr-1 sm:pr-2">
              <div v-for="(producto, index) in productosSeleccionados" :key="index" class="p-3 sm:p-4 bg-gray-50 dark:bg-gray-700/30 rounded-xl border border-gray-200 dark:border-gray-700 hover:border-orange-200 dark:hover:border-orange-800">
                <div class="flex flex-col sm:flex-row sm:justify-between sm:items-start gap-2">
                  <div class="flex-1 min-w-0">
                    <div class="flex justify-between items-start">
                      <div>
                        <p class="font-semibold text-gray-800 dark:text-white text-xs sm:text-sm">{{ producto.nombre }}</p>
                        <p class="text-[8px] sm:text-xs text-gray-500 dark:text-gray-400 mt-0.5">Código: {{ producto.codigo }}</p>
                      </div>
                      <button @click="removerProducto(index)" class="p-1 text-red-600 hover:text-red-800 dark:text-red-400 dark:hover:text-red-300 hover:bg-red-50 dark:hover:bg-red-900/30 rounded-lg flex-shrink-0">
                        <Icon icon="mdi:delete" class="text-base sm:text-lg" />
                      </button>
                    </div>
                    <p class="text-[8px] sm:text-xs text-gray-500 dark:text-gray-400 mt-1 sm:mt-2"><span class="font-medium">Stock:</span> {{ producto.stock || 0 }} unidades</p>
                    <div class="grid grid-cols-1 sm:grid-cols-2 gap-2 sm:gap-3 mt-2 sm:mt-3">
                      <div>
                        <label class="block text-[8px] sm:text-xs text-gray-500 dark:text-gray-400 mb-0.5 sm:mb-1">Cantidad</label>
                        <input v-model.number="producto.cantidad" type="number" min="1" class="w-full px-2 sm:px-3 py-1 sm:py-2 border border-gray-200 dark:border-gray-600 rounded-lg text-center bg-white dark:bg-gray-700 focus:ring-2 focus:ring-orange-500 text-[10px] sm:text-sm" @change="actualizarSubtotalProducto(producto)" />
                      </div>
                      <div>
                        <label class="block text-[8px] sm:text-xs text-gray-500 dark:text-gray-400 mb-0.5 sm:mb-1">Precio USD</label>
                        <div class="relative">
                          <span class="absolute left-2 sm:left-3 top-1/2 transform -translate-y-1/2 text-gray-500 text-[10px] sm:text-sm">$</span>
                          <input v-model.number="producto.precio_unitario_usd" type="number" min="0" step="0.01" class="w-full pl-6 sm:pl-8 pr-2 sm:pr-3 py-1 sm:py-2 border border-gray-200 dark:border-gray-600 rounded-lg text-right bg-white dark:bg-gray-700 focus:ring-2 focus:ring-orange-500 font-medium text-[10px] sm:text-sm" @change="actualizarSubtotalProducto(producto)" />
                        </div>
                      </div>
                      <div class="sm:col-span-2">
                        <label class="block text-[8px] sm:text-xs text-gray-500 dark:text-gray-400 mb-0.5 sm:mb-1">Garantía (meses)</label>
                        <input v-model.number="producto.garantia_meses" type="number" min="0" step="1" class="w-full px-2 sm:px-3 py-1 sm:py-2 border border-gray-200 dark:border-gray-600 rounded-lg text-center bg-white dark:bg-gray-700 focus:ring-2 focus:ring-orange-500 text-[10px] sm:text-sm" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            
            <div v-else-if="clienteSeleccionado" class="text-center py-8 sm:py-12">
              <div class="p-3 sm:p-4 bg-gray-50 dark:bg-gray-700/30 rounded-full w-14 sm:w-20 h-14 sm:h-20 mx-auto mb-3 sm:mb-4 flex items-center justify-center">
                <Icon icon="mdi:cart-outline" class="text-3xl sm:text-4xl text-gray-400" />
              </div>
              <p class="text-xs sm:text-sm text-gray-600 dark:text-gray-400 font-medium">No hay productos agregados</p>
              <p class="text-[9px] sm:text-xs text-gray-500 dark:text-gray-500 mt-0.5 sm:mt-1">Escanea un código o haz clic en "Agregar"</p>
            </div>
          </div>
        </div>

        <!-- Resumen y Total -->
        <div class="bg-white dark:bg-gray-800 rounded-2xl shadow-md border border-gray-200 dark:border-gray-700 overflow-hidden">
          <div class="bg-gradient-to-r from-indigo-50 to-purple-50 dark:from-gray-800 dark:to-gray-800 px-3 sm:px-4 py-2 sm:py-3 border-b border-gray-100 dark:border-gray-700">
            <h2 class="text-sm sm:text-lg font-semibold text-gray-800 dark:text-white flex items-center">
              <div class="p-1.5 sm:p-2 bg-indigo-100 dark:bg-indigo-900/30 rounded-lg mr-2 sm:mr-3">
                <Icon icon="mdi:calculator" class="text-indigo-600 dark:text-indigo-400 text-base sm:text-xl" />
              </div>
              Resumen de la Venta
            </h2>
          </div>
          <div class="p-3 sm:p-4 space-y-2 sm:space-y-3">
            <div class="space-y-2 sm:space-y-3">
              <div class="flex justify-between items-center py-1.5 sm:py-2">
                <span class="text-[10px] sm:text-sm text-gray-600 dark:text-gray-400">Subtotal USD:</span>
                <span class="font-semibold text-gray-800 dark:text-white text-xs sm:text-base">$ {{ subtotal.toFixed(2) }}</span>
              </div>
              <div class="flex justify-between items-center py-1.5 sm:py-2">
                <span class="text-[10px] sm:text-sm text-gray-600 dark:text-gray-400">Descuento USD:</span>
                <div class="flex items-center gap-1 sm:gap-2">
                  <span class="text-gray-400 text-[10px] sm:text-sm">$</span>
                  <input v-model.number="form.descuento_usd" type="number" min="0" step="0.01" class="w-16 sm:w-24 px-2 sm:px-3 py-1 sm:py-2 border border-gray-200 dark:border-gray-600 rounded-lg text-right bg-white dark:bg-gray-700 focus:ring-2 focus:ring-indigo-500 text-[10px] sm:text-sm" @change="calcularTotales" />
                </div>
              </div>

              <!-- CHECKBOX DE IVA -->
              <div class="flex items-center justify-between py-1.5 sm:py-2 bg-gray-50 dark:bg-gray-700/30 -mx-2 sm:-mx-3 px-2 sm:px-3 rounded-lg border border-dashed border-gray-300 dark:border-gray-600">
                <label class="flex items-center gap-2 cursor-pointer select-none">
                  <input 
                    type="checkbox" 
                    v-model="form.aplicar_iva" 
                    @change="calcularTotales"
                    class="w-4 h-4 text-emerald-600 bg-gray-100 border-gray-300 rounded focus:ring-emerald-500 dark:focus:ring-emerald-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600 cursor-pointer"
                  />
                  <span class="text-[10px] sm:text-sm text-gray-700 dark:text-gray-300 font-bold flex items-center gap-1">
                    <Icon icon="mdi:receipt-text" class="text-emerald-600 dark:text-emerald-400" />
                    Aplicar IVA
                  </span>
                </label>
                
                <div v-if="form.aplicar_iva" class="flex items-center gap-1 sm:gap-2">
                  <input 
                    v-model.number="form.iva_porcentaje" 
                    type="number" 
                    min="0" 
                    max="100" 
                    step="0.01"
                    @change="calcularTotales"
                    class="w-14 sm:w-20 px-2 sm:px-3 py-1 sm:py-2 border border-emerald-300 dark:border-emerald-700 rounded-lg text-right bg-white dark:bg-gray-700 focus:ring-2 focus:ring-emerald-500 text-[10px] sm:text-sm font-bold text-emerald-700 dark:text-emerald-400"
                  />
                  <span class="text-emerald-700 dark:text-emerald-400 text-[10px] sm:text-sm font-bold">%</span>
                </div>
              </div>

              <div v-if="form.aplicar_iva" class="flex justify-between items-center py-1.5 sm:py-2 bg-emerald-50 dark:bg-emerald-900/20 -mx-2 sm:-mx-3 px-2 sm:px-3 rounded-lg border border-emerald-200 dark:border-emerald-800">
                <span class="text-[10px] sm:text-sm text-emerald-700 dark:text-emerald-300 font-bold flex items-center gap-1">
                  <Icon icon="mdi:percent" class="text-sm" />
                  IVA {{ form.iva_porcentaje }}%:
                </span>
                <span class="font-bold text-emerald-700 dark:text-emerald-300 text-xs sm:text-base">
                  $ {{ ivaCalculadoUsd.toFixed(2) }}
                </span>
              </div>

              <!-- 🆕 GANANCIA - SOLO PARA ADMINISTRADORES -->
              <div v-if="puedeVerGanancia" class="flex justify-between items-center py-1.5 sm:py-2 bg-emerald-50 dark:bg-emerald-900/20 -mx-2 sm:-mx-3 px-2 sm:px-3 rounded-lg border border-emerald-200 dark:border-emerald-800">
                <span class="text-[10px] sm:text-sm text-emerald-700 dark:text-emerald-300 font-bold flex items-center gap-1">
                  <Icon icon="mdi:cash-plus" class="text-sm" />
                  Ganancia estimada:
                </span>
                <span class="font-bold text-emerald-700 dark:text-emerald-300 text-xs sm:text-base">
                  $ {{ gananciaEstimada.toFixed(2) }}
                </span>
              </div>

              <div class="border-t border-gray-200 dark:border-gray-700 pt-3 sm:pt-4 mt-1 sm:mt-2">
                <div class="flex justify-between items-center">
                  <span class="font-bold text-gray-800 dark:text-white text-sm sm:text-lg">Total USD:</span>
                  <span class="font-bold text-xl sm:text-2xl text-indigo-600 dark:text-indigo-400">$ {{ total.toFixed(2) }}</span>
                </div>
                <div v-if="tasaSeleccionada" class="flex justify-between items-center mt-2 sm:mt-3 text-[10px] sm:text-sm bg-gray-50 dark:bg-gray-700/30 p-2 sm:p-3 rounded-xl">
                  <span class="text-gray-600 dark:text-gray-400">Total en Bs:</span>
                  <span class="font-semibold text-gray-800 dark:text-white">Bs. {{ (total * tasaSeleccionada.precio_usd_bs).toFixed(2) }}</span>
                </div>
              </div>
            </div>

            <!-- SECCIÓN DE PAGO -->
            <div class="border-t border-gray-200 dark:border-gray-700 pt-3 sm:pt-4">
              <h3 class="text-xs sm:text-md font-medium text-gray-800 dark:text-white mb-2 sm:mb-4 flex items-center gap-1 sm:gap-2">
                <div class="p-1 bg-emerald-100 dark:bg-emerald-900/30 rounded-lg">
                  <Icon icon="mdi:cash-multiple" class="text-emerald-600 dark:text-emerald-400 text-sm sm:text-base" />
                </div>
                Información del Pago
              </h3>
              
              <div class="mb-3 sm:mb-4">
                <label class="block text-[10px] sm:text-sm font-medium text-gray-700 dark:text-gray-300 mb-1 sm:mb-2">Método de Pago <span class="text-red-500">*</span></label>
                <select v-model="form.idMetodoPago" class="w-full px-3 sm:px-4 py-1.5 sm:py-2 border border-gray-200 dark:border-gray-600 rounded-xl bg-white dark:bg-gray-700 focus:ring-2 focus:ring-emerald-500 text-[10px] sm:text-sm" @change="onMetodoPagoChange">
                  <option value="">Seleccionar método...</option>
                  <option v-for="metodo in metodosPago" :key="metodo.idMetodoPago" :value="metodo.idMetodoPago">{{ metodo.nombre }}</option>
                </select>
              </div>
              
              <!-- Punto de Venta -->
              <div v-if="esPuntoVenta" class="space-y-3 sm:space-y-4 p-3 sm:p-5 bg-gradient-to-r from-yellow-50 to-amber-50 dark:from-gray-800 dark:to-gray-800 rounded-xl border-2 border-yellow-400 dark:border-yellow-600">
                <div class="flex items-center gap-1 sm:gap-2 text-yellow-800 dark:text-yellow-200">
                  <Icon icon="mdi:credit-card" class="text-base sm:text-xl" />
                  <span class="font-semibold text-xs sm:text-sm">Punto de Venta</span>
                  <span class="ml-1 sm:ml-2 text-[8px] sm:text-xs bg-yellow-200 text-yellow-800 dark:bg-yellow-900/50 dark:text-yellow-300 px-1.5 sm:px-2 py-0.5 rounded-full">Requiere referencia</span>
                </div>
                
                <div class="bg-yellow-100 dark:bg-yellow-900/30 p-3 sm:p-4 rounded-xl border border-yellow-200 dark:border-yellow-800">
                  <p class="text-[10px] sm:text-sm font-medium text-yellow-800 dark:text-yellow-200 mb-2 sm:mb-3 flex items-center gap-1 sm:gap-2">
                    <Icon icon="mdi:form-textbox" class="text-base sm:text-lg" />
                    Datos de la Transacción
                  </p>
                  <div>
                    <label class="block text-[10px] sm:text-sm font-medium text-gray-700 dark:text-gray-300 mb-1 sm:mb-2">N° de Referencia <span class="text-red-500">*</span></label>
                    <input 
                      v-model="puntoVenta.referencia" 
                      type="text" 
                      inputmode="numeric"
                      maxlength="4"
                      placeholder="4 dígitos"
                      @input="puntoVenta.referencia = puntoVenta.referencia.replace(/[^0-9]/g, '').slice(0, 4)"
                      class="w-full px-3 sm:px-4 py-2 sm:py-3 border-2 border-yellow-400 dark:border-yellow-600 rounded-xl bg-white dark:bg-gray-700 focus:ring-2 focus:ring-yellow-500 text-center text-xl sm:text-2xl font-mono tracking-widest"
                    />
                  </div>
                </div>
              </div>
              
              <!-- Pago Móvil -->
              <div v-if="esPagoMovil" class="space-y-3 sm:space-y-4 p-3 sm:p-5 bg-gradient-to-r from-blue-50 to-sky-50 dark:from-gray-800 dark:to-gray-800 rounded-xl border border-blue-200 dark:border-blue-800/50">
                <div class="flex items-center gap-1 sm:gap-2 text-blue-800 dark:text-blue-200">
                  <Icon icon="mdi:cellphone" class="text-base sm:text-xl" />
                  <span class="font-semibold text-xs sm:text-sm">Pago Móvil</span>
                </div>
                <div class="grid grid-cols-1 sm:grid-cols-2 gap-2 sm:gap-4">
                  <div>
                    <label class="block text-[8px] sm:text-xs font-medium text-gray-700 dark:text-gray-300 mb-0.5 sm:mb-1">Cédula de quien paga <span class="text-red-500">*</span></label>
                    <input v-model="pagoMovil.cedula" type="text" placeholder="V-12345678" class="w-full px-2 sm:px-4 py-1.5 sm:py-2 border border-gray-200 dark:border-gray-600 rounded-xl bg-white dark:bg-gray-700 focus:ring-2 focus:ring-blue-500 text-[10px] sm:text-sm" />
                  </div>
                  <div>
                    <label class="block text-[8px] sm:text-xs font-medium text-gray-700 dark:text-gray-300 mb-0.5 sm:mb-1">Teléfono <span class="text-red-500">*</span></label>
                    <input v-model="pagoMovil.telefono" type="text" placeholder="0414-1234567" class="w-full px-2 sm:px-4 py-1.5 sm:py-2 border border-gray-200 dark:border-gray-600 rounded-xl bg-white dark:bg-gray-700 focus:ring-2 focus:ring-blue-500 text-[10px] sm:text-sm" />
                  </div>
                  <div>
                    <label class="block text-[8px] sm:text-xs font-medium text-gray-700 dark:text-gray-300 mb-0.5 sm:mb-1">Banco Origen <span class="text-red-500">*</span></label>
                    <select v-model="pagoMovil.banco_origen" class="w-full px-2 sm:px-4 py-1.5 sm:py-2 border border-gray-200 dark:border-gray-600 rounded-xl bg-white dark:bg-gray-700 focus:ring-2 focus:ring-blue-500 text-[10px] sm:text-sm">
                      <option value="">Seleccionar...</option>
                      <option v-for="banco in bancosVenezuela" :key="banco" :value="banco">{{ banco }}</option>
                    </select>
                  </div>
                  <div>
                    <label class="block text-[8px] sm:text-xs font-medium text-gray-700 dark:text-gray-300 mb-0.5 sm:mb-1">N° Referencia <span class="text-red-500">*</span></label>
                    <input v-model="pagoMovil.referencia" type="text" placeholder="Referencia" class="w-full px-2 sm:px-4 py-1.5 sm:py-2 border border-gray-200 dark:border-gray-600 rounded-xl bg-white dark:bg-gray-700 focus:ring-2 focus:ring-blue-500 text-[10px] sm:text-sm" />
                  </div>
                </div>
              </div>
              
              <!-- Transferencia -->
              <div v-if="esTransferencia" class="space-y-3 sm:space-y-4 p-3 sm:p-5 bg-gradient-to-r from-purple-50 to-violet-50 dark:from-gray-800 dark:to-gray-800 rounded-xl border border-purple-200 dark:border-purple-800/50">
                <div class="flex items-center gap-1 sm:gap-2 text-purple-800 dark:text-purple-200"><Icon icon="mdi:bank-transfer" class="text-base sm:text-xl" /><span class="font-semibold text-xs sm:text-sm">Transferencia</span></div>
                <div class="grid grid-cols-1 sm:grid-cols-2 gap-2 sm:gap-4">
                  <div><label class="block text-[8px] sm:text-xs font-medium text-gray-700 dark:text-gray-300 mb-0.5 sm:mb-1">N° Referencia <span class="text-red-500">*</span></label><input v-model="transferencia.referencia" type="text" placeholder="Referencia" class="w-full px-2 sm:px-4 py-1.5 sm:py-2 border border-gray-200 dark:border-gray-600 rounded-xl bg-white dark:bg-gray-700 focus:ring-2 focus:ring-purple-500 text-[10px] sm:text-sm" /></div>
                  <div><label class="block text-[8px] sm:text-xs font-medium text-gray-700 dark:text-gray-300 mb-0.5 sm:mb-1">Banco Origen <span class="text-red-500">*</span></label><select v-model="transferencia.banco_origen" class="w-full px-2 sm:px-4 py-1.5 sm:py-2 border border-gray-200 dark:border-gray-600 rounded-xl bg-white dark:bg-gray-700 focus:ring-2 focus:ring-purple-500 text-[10px] sm:text-sm"><option value="">Seleccionar...</option><option v-for="banco in bancosVenezuela" :key="banco" :value="banco">{{ banco }}</option></select></div>
                  <div><label class="block text-[8px] sm:text-xs font-medium text-gray-700 dark:text-gray-300 mb-0.5 sm:mb-1">Banco Destino <span class="text-red-500">*</span></label><select v-model="transferencia.banco_destino" class="w-full px-2 sm:px-4 py-1.5 sm:py-2 border border-gray-200 dark:border-gray-600 rounded-xl bg-white dark:bg-gray-700 focus:ring-2 focus:ring-purple-500 text-[10px] sm:text-sm" @change="autocompletarDatosTransferencia"><option value="">Seleccionar...</option><option v-for="banco in bancosEmpresa" :key="banco.id" :value="banco.nombre">{{ banco.nombre }}</option></select></div>
                  <div><label class="block text-[8px] sm:text-xs font-medium text-gray-700 dark:text-gray-300 mb-0.5 sm:mb-1">N° Cuenta <span class="text-red-500">*</span></label><input v-model="transferencia.numero_cuenta" type="text" readonly placeholder="Seleccione banco" class="w-full px-2 sm:px-4 py-1.5 sm:py-2 border border-gray-200 dark:border-gray-600 rounded-xl bg-gray-50 dark:bg-gray-700/50 text-gray-600 dark:text-gray-400 cursor-not-allowed text-[8px] sm:text-xs" /></div>
                </div>
              </div>
              
              <!-- Efectivo -->
              <div v-if="esEfectivo" class="p-3 sm:p-5 bg-gradient-to-r from-green-50 to-emerald-50 dark:from-gray-800 dark:to-gray-800 rounded-xl border border-green-200 dark:border-green-800/50">
                <div class="flex items-center gap-2 sm:gap-3 text-green-800 dark:text-green-200"><Icon icon="mdi:cash" class="text-xl sm:text-2xl" /><div><p class="font-semibold text-xs sm:text-sm">Pago en Efectivo</p><p class="text-[10px] sm:text-sm opacity-75">No requiere información adicional</p></div></div>
              </div>
            </div>

            <!-- Tasas y Vendedor -->
            <div class="border-t border-gray-200 dark:border-gray-700 pt-3 sm:pt-4 space-y-2 sm:space-y-4">
              <div v-if="tasaSeleccionada">
                <label class="block text-[10px] sm:text-sm font-medium text-gray-700 dark:text-gray-300 mb-1 sm:mb-2">Tasa de Cambio (Bs/USD)</label>
                <div class="p-2 sm:p-3 bg-gray-50 dark:bg-gray-700/30 rounded-xl border border-gray-200 dark:border-gray-700">
                  <div class="grid grid-cols-2 gap-1 sm:gap-2 text-[9px] sm:text-sm">
                    <div><span class="text-gray-500 dark:text-gray-400 block text-[8px] sm:text-xs">Fuente:</span><span class="font-medium text-gray-800 dark:text-white">{{ tasaSeleccionada.fuenteTasa?.nombre || tasaSeleccionada.nombreFuente || 'N/A' }}</span></div>
                    <div><span class="text-gray-500 dark:text-gray-400 block text-[8px] sm:text-xs">Tasa:</span><span class="font-medium text-emerald-600 dark:text-emerald-400">Bs. {{ tasaSeleccionada.precio_usd_bs.toFixed(2) }}</span></div>
                  </div>
                </div>
              </div>
              <div>
                <label class="block text-[8px] sm:text-xs font-medium text-gray-700 dark:text-gray-300 mb-0.5 sm:mb-1">Vendedor <span class="text-red-500">*</span></label>
                <div class="relative">
                  <Icon icon="mdi:account-tie" class="absolute left-3 top-1/2 transform -translate-y-1/2 text-blue-500 text-sm sm:text-base" />
                  <input 
                    :value="vendedorActual ? `${vendedorActual.nombre} ${vendedorActual.apellido}` : 'Cargando...'" 
                    type="text" 
                    readonly 
                    class="w-full pl-9 sm:pl-10 pr-3 sm:pr-4 py-1.5 sm:py-2 border border-gray-200 dark:border-gray-600 rounded-xl bg-gray-50 dark:bg-gray-700/50 text-gray-700 dark:text-gray-300 cursor-not-allowed font-medium text-[10px] sm:text-sm" 
                  />
                </div>
              </div>
            </div>
            
            <div class="pt-1 sm:pt-2">
              <button @click="crearVenta" :disabled="!puedeCrearVenta || guardando" :class="['w-full px-3 sm:px-4 py-2 sm:py-3 rounded-xl transition-all duration-200 flex items-center justify-center gap-1 sm:gap-2 font-semibold text-sm sm:text-lg shadow-lg hover:shadow-xl', puedeCrearVenta && !guardando ? 'bg-gradient-to-r from-green-600 to-emerald-600 text-white hover:from-green-700 hover:to-emerald-700' : 'bg-gray-200 dark:bg-gray-700 text-gray-500 dark:text-gray-400 cursor-not-allowed']">
                <Icon v-if="guardando" icon="mdi:loading" class="animate-spin text-base sm:text-xl" />
                <Icon v-else icon="mdi:check-circle-outline" class="text-base sm:text-xl" />
                {{ guardando ? 'Creando Venta...' : 'Crear Venta' }}
              </button>
              <div v-if="!puedeCrearVenta && !guardando" class="mt-2 sm:mt-3 space-y-0.5 sm:space-y-1">
                <p v-if="!clienteSeleccionado" class="text-[8px] sm:text-xs text-red-600 dark:text-red-400 flex items-center gap-0.5 sm:gap-1"><Icon icon="mdi:alert-circle" class="text-sm" /> Falta: Seleccionar un cliente</p>
                <p v-else-if="productosSeleccionados.length === 0" class="text-[8px] sm:text-xs text-red-600 dark:text-red-400 flex items-center gap-0.5 sm:gap-1"><Icon icon="mdi:alert-circle" class="text-sm" /> Falta: Agregar al menos un producto</p>
                <p v-else-if="!form.idVendedor" class="text-[8px] sm:text-xs text-red-600 dark:text-red-400 flex items-center gap-0.5 sm:gap-1"><Icon icon="mdi:alert-circle" class="text-sm" /> Falta: Seleccionar vendedor</p>
                <p v-else-if="!form.idTasaVenta" class="text-[8px] sm:text-xs text-red-600 dark:text-red-400 flex items-center gap-0.5 sm:gap-1"><Icon icon="mdi:alert-circle" class="text-sm" /> Falta: Seleccionar tasa de cambio</p>
                <p v-else-if="!form.idMetodoPago" class="text-[8px] sm:text-xs text-red-600 dark:text-red-400 flex items-center gap-0.5 sm:gap-1"><Icon icon="mdi:alert-circle" class="text-sm" /> Falta: Seleccionar método de pago</p>
                <p v-else-if="!form.numero_factura" class="text-[8px] sm:text-xs text-red-600 dark:text-red-400 flex items-center gap-0.5 sm:gap-1"><Icon icon="mdi:alert-circle" class="text-sm" /> Falta: Número de factura</p>
                <p v-else-if="esPuntoVenta && !validarPuntoVenta" class="text-[8px] sm:text-xs text-red-600 dark:text-red-400 flex items-center gap-0.5 sm:gap-1"><Icon icon="mdi:alert-circle" class="text-sm" /> Falta: Ingresar número de referencia (4 dígitos)</p>
                <p v-else-if="esPagoMovil && !validarPagoMovil" class="text-[8px] sm:text-xs text-red-600 dark:text-red-400 flex items-center gap-0.5 sm:gap-1"><Icon icon="mdi:alert-circle" class="text-sm" /> Falta: Completar todos los datos de pago móvil</p>
                <p v-else-if="esTransferencia && !validarTransferencia" class="text-[8px] sm:text-xs text-red-600 dark:text-red-400 flex items-center gap-0.5 sm:gap-1"><Icon icon="mdi:alert-circle" class="text-sm" /> Falta: Completar todos los datos de transferencia</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal de Productos -->
    <Teleport to="body">
      <div v-if="showModalProductos" class="fixed inset-0 z-50 overflow-hidden flex items-center justify-center p-2 sm:p-4" role="dialog">
        <div class="absolute inset-0 bg-black/60 backdrop-blur-sm" @click="cerrarModalProductos"></div>

        <div class="relative bg-white dark:bg-gray-800 rounded-2xl shadow-2xl w-full max-w-4xl max-h-[90vh] flex flex-col overflow-hidden transform transition-all animate-zoomIn">
          <div class="p-3 sm:p-6 border-b border-gray-200 dark:border-gray-700 flex-shrink-0">
            <div class="flex justify-between items-center">
              <h3 class="text-base sm:text-xl font-bold text-gray-900 dark:text-white flex items-center gap-1 sm:gap-2">
                <div class="p-1.5 sm:p-2 bg-orange-100 dark:bg-orange-900/30 rounded-lg">
                  <Icon icon="mdi:package-variant" class="text-orange-600 dark:text-orange-400 text-lg sm:text-xl" />
                </div>
                Seleccionar Productos
              </h3>
              <button @click="cerrarModalProductos" class="p-1.5 sm:p-2 hover:bg-gray-100 dark:hover:bg-gray-700 rounded-xl">
                <Icon icon="mdi:close" class="text-xl sm:text-2xl text-gray-500 dark:text-gray-400" />
              </button>
            </div>
            <div class="mt-2 sm:mt-4">
              <div class="relative">
                <Icon icon="mdi:magnify" class="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" />
                <input v-model="buscarProducto" type="text" placeholder="Buscar producto por nombre o código..." class="w-full pl-9 sm:pl-12 pr-3 sm:pr-4 py-2 sm:py-3 border border-gray-200 dark:border-gray-600 rounded-xl bg-white dark:bg-gray-700 focus:ring-2 focus:ring-orange-500 text-xs sm:text-sm" @input="debounceBuscarProductos" />
              </div>
            </div>
          </div>
          
          <div class="p-3 sm:p-6 overflow-y-auto flex-1 custom-scrollbar">
            <div v-if="cargandoProductos" class="text-center py-8 sm:py-12">
              <div class="inline-block animate-spin rounded-full h-6 sm:h-8 w-6 sm:w-8 border-3 border-orange-500 border-t-transparent"></div>
              <p class="text-gray-500 dark:text-gray-400 mt-2 sm:mt-3 text-sm">Buscando productos...</p>
            </div>
            <div v-else-if="productosParaMostrar.length > 0" class="grid grid-cols-1 sm:grid-cols-2 gap-3 sm:gap-4">
              <div v-for="producto in productosParaMostrar" :key="producto.idProducto" @click="agregarProducto(producto)" class="p-3 sm:p-4 border border-gray-200 dark:border-gray-700 rounded-xl hover:border-orange-500 dark:hover:border-orange-500 cursor-pointer transition-all duration-200 hover:shadow-lg hover:scale-[1.02] bg-white dark:bg-gray-800">
                <div class="flex gap-2 sm:gap-3">
                  <div class="w-14 h-14 sm:w-20 sm:h-20 rounded-lg overflow-hidden bg-gray-100 flex-shrink-0 border border-gray-200">
                    <img 
                      v-if="getImageUrl(producto.imagen)" 
                      :src="getImageUrl(producto.imagen)" 
                      :alt="producto.nombre"
                      class="w-full h-full object-cover"
                      @error="handleImageError"
                    />
                    <div v-else class="w-full h-full flex items-center justify-center text-gray-300">
                      <Icon icon="mdi:package-variant" class="text-3xl sm:text-4xl" />
                    </div>
                  </div>
                  <div class="flex-1 min-w-0">
                    <h4 class="font-semibold text-gray-900 dark:text-white text-xs sm:text-sm">{{ producto.nombre }}</h4>
                    <p class="text-[8px] sm:text-xs text-gray-500 dark:text-gray-400 mt-0.5">Código: {{ producto.codigo }}</p>
                    <div class="flex flex-wrap items-center gap-1 sm:gap-3 mt-1 sm:mt-2 text-[8px] sm:text-xs">
                      <span class="px-1.5 sm:px-2 py-0.5 sm:py-1 bg-gray-100 dark:bg-gray-700 rounded-lg">Stock: {{ producto.stock || 0 }}</span>
                      <span class="px-1.5 sm:px-2 py-0.5 sm:py-1 bg-gray-100 dark:bg-gray-700 rounded-lg">Cat: {{ producto.categoria || 'General' }}</span>
                    </div>
                    <div class="mt-2 sm:mt-3 flex justify-between items-center">
                      <span class="text-[10px] sm:text-sm text-gray-600 dark:text-gray-400">Precio USD:</span>
                      <span class="text-base sm:text-lg font-bold text-orange-600 dark:text-orange-400">$ {{ (producto.precio_venta_usd || 0).toFixed(2) }}</span>
                    </div>
                    <div v-if="productoYaAgregado(producto)" class="mt-1 sm:mt-2">
                      <span class="inline-flex items-center gap-0.5 sm:gap-1 text-[8px] sm:text-xs bg-green-100 text-green-700 dark:bg-green-900/30 dark:text-green-400 px-1.5 sm:px-2 py-0.5 sm:py-1 rounded-lg"><Icon icon="mdi:check" />Ya agregado</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div v-else-if="buscarProducto && buscarProducto.trim().length >= 2" class="text-center py-8 sm:py-12">
              <Icon icon="mdi:package-variant-closed" class="text-4xl sm:text-5xl text-gray-400 mx-auto mb-2 sm:mb-3" />
              <p class="text-gray-600 dark:text-gray-400 text-sm">No se encontraron productos para "<strong>{{ buscarProducto }}</strong>"</p>
            </div>
            <div v-else class="text-center py-8 sm:py-12">
              <Icon icon="mdi:package-variant" class="text-4xl sm:text-5xl text-gray-400 mx-auto mb-2 sm:mb-3" />
              <p class="text-gray-600 dark:text-gray-400 text-sm">No hay productos disponibles</p>
            </div>
          </div>
          
          <div class="p-3 sm:p-6 border-t border-gray-200 dark:border-gray-700 bg-gray-50 dark:bg-gray-800/50 flex-shrink-0">
            <div class="flex flex-col sm:flex-row justify-between items-center gap-2 sm:gap-0">
              <p class="text-[10px] sm:text-sm text-gray-600 dark:text-gray-400"><span class="font-semibold text-gray-800 dark:text-white">{{ productosSeleccionados.length }}</span> productos seleccionados</p>
              <button @click="cerrarModalProductos" class="w-full sm:w-auto px-4 sm:px-6 py-2 bg-gradient-to-r from-orange-600 to-amber-600 text-white rounded-xl hover:from-orange-700 hover:to-amber-700 transition-all duration-200 font-medium shadow-md hover:shadow-lg text-[10px] sm:text-sm">Cerrar</button>
            </div>
          </div>
        </div>
      </div>
    </Teleport>

    <!-- MODAL DE CONFIRMACIÓN -->
    <Teleport to="body">
      <div v-if="showConfirmModal" class="fixed inset-0 bg-black/60 backdrop-blur-sm flex items-center justify-center p-3 sm:p-4 z-[60]">
        <div class="bg-white dark:bg-gray-800 rounded-2xl shadow-2xl w-full max-w-md overflow-hidden animate-zoomIn">
          <div class="p-4 sm:p-6">
            <div class="flex justify-center mb-3 sm:mb-4">
              <div class="p-2 sm:p-3 rounded-full" :class="confirmModalIconClass">
                <Icon :icon="confirmModalIcon" class="text-3xl sm:text-4xl" :class="confirmModalIconColor" />
              </div>
            </div>
            <h3 class="text-lg sm:text-xl font-bold text-center text-gray-900 dark:text-white mb-1 sm:mb-2">{{ confirmModalTitle }}</h3>
            <p class="text-center text-gray-600 dark:text-gray-400 text-xs sm:text-sm mb-4 sm:mb-6" v-html="confirmModalMessage"></p>
            <div class="flex flex-col sm:flex-row gap-2 sm:gap-3">
              <button v-if="confirmModalType !== 'info'" @click="cancelarConfirmacion" class="w-full sm:flex-1 px-3 sm:px-4 py-2 sm:py-3 border border-gray-200 dark:border-gray-600 text-gray-700 dark:text-gray-300 rounded-xl hover:bg-gray-50 dark:hover:bg-gray-700 transition-all duration-200 text-[10px] sm:text-sm">{{ confirmModalCancelText }}</button>
              <button @click="aceptarConfirmacion" class="w-full sm:flex-1 px-3 sm:px-4 py-2 sm:py-3 rounded-xl transition-all duration-200 font-medium text-white text-[10px] sm:text-sm" :class="confirmModalConfirmClass">{{ confirmModalConfirmText }}</button>
            </div>
          </div>
        </div>
      </div>
    </Teleport>
  </div>
</template>

<script>
import { Icon } from "@iconify/vue";
import { useToast } from "vue-toastification";
import { notificarVenta } from '@/utils/notificacionesHelper';
import { imprimirFactura } from '@/utils/facturaGenerator.js';
import { crearVenta, registrarPagoVenta, obtenerSiguienteNumeroFactura } from '@/api/ventas.js';
import { obtenerClientes, crearCliente, formatearDocumento, formatearTelefonoVenezolano } from '@/api/clientes.js';
import { obtenerProductos, obtenerProductoPorCodigo, obtenerProductoPorCodigoBarras, obtenerUrlImagen } from '@/api/productos.js';
import { obtenerVendedores, obtenerVendedorPorIdUsuario } from '@/api/vendedores.js';
import { obtenerTasasVenta } from '@/api/tasaVenta.js';
import { obtenerMetodosPago } from '@/api/metodosPago.api.js';
import { getCurrentUser, hasRole } from "@/utils/permissionUtils";

export default {
  name: 'VentasCreate',
  components: { Icon },
  setup() {
    const toast = useToast();
    return { toast };
  },
  data() {
    return {
      form: {
        numero_factura: '',
        fecha_venta: new Date().toISOString(),
        tipo_venta: 'CONTADO',
        descuento_usd: 0,
        descuento_bs: 0,
        tasa_bs_usd: 0,
        idFuenteTasaVenta: null,
        idTasaVenta: '',
        idVendedor: null,
        idUsuario: null,
        idCliente: null,
        observaciones: '',
        estado: 'Completada',
        idMetodoPago: '',
        monto_pagado_inicial: 0,
        aplicar_iva: false,
        iva_porcentaje: 16,
      },
      ivaMonto: 0,
      ivaMontoBs: 0,
      baseImponible: 0,
      puntoVenta: { referencia: '' },
      pagoMovil: { cedula: '', telefono: '', referencia: '', banco_origen: '' },
      transferencia: { referencia: '', banco_origen: '', banco_destino: '', numero_cuenta: '' },
      modoCliente: 'buscar',
      buscarCliente: '',
      clientesEncontrados: [],
      clienteSeleccionado: null,
      cargandoClientes: false,
      mostrarListaClientes: false,
      timeoutBusqueda: null,
      todosLosClientes: [],
      nuevoCliente: { tipoDocumento: '', documento: '', nombre: '', apellido: '', telefono: '', email: '', direccion: '', estado: 'activo' },
      guardandoCliente: false,
      productosDisponibles: [],
      productosSeleccionados: [],
      buscarProducto: '',
      productosEncontrados: [],
      cargandoProductos: false,
      showModalProductos: false,
      vendedores: [],
      tasasVenta: [],
      tasaSeleccionada: null,
      metodosPago: [],
      bancosVenezuela: [
        '0102 - Banco de Venezuela (BDV)',
        '0104 - Banco Venezolano de Crédito',
        '0105 - Mercantil Banco',
        '0108 - BBVA Provincial',
        '0114 - Bancaribe',
        '0115 - Banco Exterior',
        '0128 - Banco Caroní',
        '0134 - Banesco',
        '0137 - Banco Sofitasa',
        '0138 - Banco Plaza',
        '0151 - Banco Fondo Común (BFC)',
        '0156 - 100% Banco',
        '0157 - Del Sur',
        '0163 - Banco del Tesoro',
        '0166 - Banco Agrícola de Venezuela',
        '0168 - Bancrecer',
        '0169 - Mi Banco',
        '0171 - Banco Activo',
        '0172 - Bancamiga',
        '0174 - Banplus',
        '0175 - Banco Digital de los Trabajadores (BDT / antes Bicentenario)',
        '0177 - Banfanb',
        '0191 - Banco Nacional de Crédito (BNC)'
      ],
      bancosEmpresa: [
        { id: 1, nombre: 'Mercantil Banco', codigo: '0105', cuenta: '0105-0123-45-12345678', titular: 'SYSTEM JJ', cedula_titular: 'V-18.731.281', telefono: '0416-759.47.23' },
        { id: 2, nombre: 'Banco de Venezuela', codigo: '0102', cuenta: '0102-0123-45-12345678', titular: 'SYSTEM JJ', cedula_titular: 'V-18.731.281', telefono: '0416-759.47.23' },
        { id: 3, nombre: 'Banesco', codigo: '0134', cuenta: '0134-0123-45-12345678', titular: 'SYSTEM JJ', cedula_titular: 'V-18.731.281', telefono: '0416-759.47.23' },
        { id: 4, nombre: 'Banco Nacional de Crédito (BNC)', codigo: '0191', cuenta: '0191-0123-45-12345678', titular: 'SYSTEM JJ C.A', cedula_titular: 'J-410231190', telefono: '0412-0552022' },
        { id: 5, nombre: 'Banca Amiga', codigo: '0172', cuenta: '0172-0123-45-12345678', titular: 'SYSTEM JJ C.A', cedula_titular: 'J-410231190', telefono: '0412-0552022' }
      ],
      subtotal: 0,
      total: 0,
      guardando: false,
      loading: false,
      timeoutBusquedaProducto: null,
      showConfirmModal: false,
      confirmModalTitle: '',
      confirmModalMessage: '',
      confirmModalIcon: 'mdi:check-circle',
      confirmModalIconClass: 'bg-green-100 dark:bg-green-900/30',
      confirmModalIconColor: 'text-green-600 dark:text-green-400',
      confirmModalConfirmText: 'Aceptar',
      confirmModalCancelText: 'Cancelar',
      confirmModalType: 'success',
      confirmModalConfirmClass: 'bg-gradient-to-r from-green-600 to-emerald-600 hover:from-green-700 hover:to-emerald-700',
      confirmCallback: null,
      confirmCancelCallback: null,
      currentUser: null,
      vendedorActual: null,
      codigoEscaneadoVenta: '',
      productoEncontradoVenta: null,
      busquedaFallidaVenta: false,
      buscandoProductoVenta: false,
      // 🆕 Control de visibilidad de ganancia
      puedeVerGanancia: false,
    };
  },
  computed: {
    puedeCrearVenta() {
      const baseValid = (
        this.clienteSeleccionado && 
        (this.clienteSeleccionado.idCliente || this.clienteSeleccionado.id) && 
        this.productosSeleccionados.length > 0 && 
        this.form.idVendedor && 
        this.form.idTasaVenta && 
        this.form.idTasaVenta !== '' && 
        this.form.numero_factura && 
        this.form.idMetodoPago
      );
      if (!baseValid) return false;
      if (this.esPuntoVenta) return this.validarPuntoVenta;
      if (this.esPagoMovil) return this.validarPagoMovil;
      if (this.esTransferencia) return this.validarTransferencia;
      return true;
    },
    validarPuntoVenta() {
      return (this.puntoVenta.referencia && /^[0-9]{4}$/.test(this.puntoVenta.referencia));
    },
    validarPagoMovil() { 
      return (this.pagoMovil.cedula && 
              this.pagoMovil.telefono && 
              this.pagoMovil.referencia && 
              this.pagoMovil.banco_origen);
    },
    validarTransferencia() { 
      return (this.transferencia.referencia && 
              this.transferencia.banco_origen && 
              this.transferencia.banco_destino && 
              this.transferencia.numero_cuenta);
    },
    esPuntoVenta() { const metodo = this.metodosPago.find(m => m.idMetodoPago == this.form.idMetodoPago); return metodo?.tipo === 'punto_venta' || metodo?.nombre?.toLowerCase().includes('punto'); },
    esPagoMovil() { const metodo = this.metodosPago.find(m => m.idMetodoPago == this.form.idMetodoPago); return metodo?.tipo === 'pago_movil'; },
    esTransferencia() { const metodo = this.metodosPago.find(m => m.idMetodoPago == this.form.idMetodoPago); return metodo?.tipo === 'transferencia'; },
    esEfectivo() { const metodo = this.metodosPago.find(m => m.idMetodoPago == this.form.idMetodoPago); return metodo?.tipo === 'efectivo'; },
    puedeGuardarCliente() { return (this.nuevoCliente.tipoDocumento && this.nuevoCliente.documento && this.nuevoCliente.documento.trim() !== '' && this.nuevoCliente.nombre && this.nuevoCliente.nombre.trim() !== ''); },
    productosParaMostrar() { if (this.buscarProducto && this.buscarProducto.trim().length >= 2) return this.productosEncontrados; return this.productosDisponibles; },
    bancoDestinoSeleccionado() { return null; },
    referenciaPuntoVenta() {
      return this.puntoVenta.referencia || null;
    },
    baseImponibleCalculada() {
      const descuento = parseFloat(this.form.descuento_usd) || 0;
      return Math.max(0, this.subtotal - descuento);
    },
    ivaCalculadoUsd() {
      if (!this.form.aplicar_iva) return 0;
      const pct = parseFloat(this.form.iva_porcentaje) || 0;
      return Number(((this.baseImponibleCalculada * pct) / 100).toFixed(2));
    },
    totalConIva() {
      return Number((this.baseImponibleCalculada + this.ivaCalculadoUsd).toFixed(2));
    },
    costoTotalProductos() {
      return this.productosSeleccionados.reduce((sum, p) => sum + (parseFloat(p.costo_total) || 0), 0);
    },
    gananciaEstimada() {
      return Number((this.total - this.costoTotalProductos).toFixed(2));
    }
  },
  watch: {
    'form.idTasaVenta'(nuevoId) { this.actualizarTasaSeleccionada(); },
    'tasaSeleccionada': { handler(nuevaTasa) { if (nuevaTasa) { this.form.tasa_bs_usd = nuevaTasa.precio_usd_bs || 0; this.form.idFuenteTasaVenta = nuevaTasa.idFuenteTasa; this.calcularDescuentoBs(); this.calcularTotales(); } }, deep: true },
    'form.descuento_usd': { handler() { this.calcularTotales(); } },
    'form.aplicar_iva': { handler() { this.calcularTotales(); } },
    'form.iva_porcentaje': { handler() { this.calcularTotales(); } },
    productosSeleccionados: { handler() { this.calcularTotales(); }, deep: true }
  },
  async mounted() { 
    this.detectarRolUsuario();
    await this.cargarDatosIniciales(); 
    await this.generarNumeroOrden(); 
    await this.cargarTodosLosClientes();
    this.$nextTick(() => {
      if (this.$refs.lectorVentaInput) {
        this.$refs.lectorVentaInput.focus();
      }
    });
  },
  methods: {
    // 🆕 Detectar si el usuario puede ver la ganancia (solo admin/super_admin)
    detectarRolUsuario() {
      try {
        const user = getCurrentUser();
        const rol = (user?.rol || user?.role || user?.nombreRol || '').toLowerCase();
        const rolId = user?.idRol || user?.id_rol;
        
        this.puedeVerGanancia = 
          rol === 'administrador' || 
          rol === 'super_administrador' ||
          rol === 'admin' ||
          rolId === 1 || 
          rolId === 2 ||
          hasRole?.('administrador') || 
          hasRole?.('super_administrador');
        
        console.log('👤 Rol del usuario:', rol, '| Puede ver ganancia:', this.puedeVerGanancia);
      } catch (e) {
        console.warn('No se pudo detectar el rol del usuario:', e);
        this.puedeVerGanancia = false;
      }
    },
    mostrarToastExito(mensaje) { this.toast.success(mensaje, { timeout: 3000 }); },
    mostrarToastError(mensaje) { this.toast.error(mensaje, { timeout: 5000 }); },
    mostrarToastAdvertencia(mensaje) { this.toast.warning(mensaje, { timeout: 4000 }); },
    mostrarToastInfo(mensaje) { this.toast.info(mensaje, { timeout: 3000 }); },
    mostrarConfirmacion(options) {
      this.confirmModalTitle = options.title || 'Confirmar';
      this.confirmModalMessage = options.message || '¿Estás seguro?';
      this.confirmModalIcon = options.icon || 'mdi:help-circle';
      this.confirmModalIconClass = options.iconClass || 'bg-yellow-100 dark:bg-yellow-900/30';
      this.confirmModalIconColor = options.iconColor || 'text-yellow-600 dark:text-yellow-400';
      this.confirmModalConfirmText = options.confirmText || 'Aceptar';
      this.confirmModalCancelText = options.cancelText || 'Cancelar';
      this.confirmModalType = options.type || 'confirm';
      if (options.type === 'danger') this.confirmModalConfirmClass = 'bg-gradient-to-r from-red-600 to-rose-600 hover:from-red-700 hover:to-rose-700';
      else if (options.type === 'success') this.confirmModalConfirmClass = 'bg-gradient-to-r from-green-600 to-emerald-600 hover:from-green-700 hover:to-emerald-700';
      else if (options.type === 'warning') this.confirmModalConfirmClass = 'bg-gradient-to-r from-yellow-600 to-amber-600 hover:from-yellow-700 hover:to-amber-700';
      else this.confirmModalConfirmClass = 'bg-gradient-to-r from-blue-600 to-indigo-600 hover:from-blue-700 hover:to-indigo-700';
      this.confirmCallback = options.onConfirm || null;
      this.confirmCancelCallback = options.onCancel || null;
      this.showConfirmModal = true;
    },
    cancelarConfirmacion() { this.showConfirmModal = false; if (this.confirmCancelCallback) this.confirmCancelCallback(); },
    aceptarConfirmacion() { this.showConfirmModal = false; if (this.confirmCallback) this.confirmCallback(); },
    async generarNumeroOrden() { 
      try {
        const result = await obtenerSiguienteNumeroFactura();
        this.form.numero_factura = result.data;
      } catch (error) {
        console.error('Error generando número de factura:', error);
        this.form.numero_factura = 'FR-6000';
      }
    },
    getImageUrl(imagen) {
      return obtenerUrlImagen(imagen);
    },
    handleImageError(event) { 
      event.target.style.display = 'none'; 
    },
    async buscarProductoPorCodigoVenta() {
      const codigo = this.codigoEscaneadoVenta.trim();
      if (!codigo) { this.toast.warning('Ingresa o escanea un código'); return; }
      if (!this.clienteSeleccionado) { this.toast.warning('Primero selecciona un cliente'); return; }

      let producto = this.productosDisponibles.find(p => {
        const codigoEsc = codigo.toLowerCase();
        return p.codigo?.toLowerCase() === codigoEsc || p.codigoBarras?.toLowerCase() === codigoEsc;
      });

      if (!producto) {
        this.buscandoProductoVenta = true;
        try {
          let resultado = await obtenerProductoPorCodigo(codigo);
          if (!resultado.success || !resultado.data) {
            resultado = await obtenerProductoPorCodigoBarras(codigo);
          }
          if (resultado.success && resultado.data) {
            producto = resultado.data;
            const existe = this.productosDisponibles.some(p => p.idProducto === producto.idProducto);
            if (!existe) {
              this.productosDisponibles.push({
                ...producto,
                precio_unitario_usd: producto.precio_venta_usd || 0,
                costo_unitario_usd: producto.costo_unitario_usd || producto.precio_compra_usdt || 0
              });
            }
          }
        } catch (error) {
          console.error('❌ Error buscando producto:', error);
          this.toast.error('Error al buscar el producto');
          this.buscandoProductoVenta = false;
          return;
        }
        this.buscandoProductoVenta = false;
      }

      if (producto) {
        this.productoEncontradoVenta = producto;
        this.busquedaFallidaVenta = false;
        this.codigoEscaneadoVenta = '';
        this.$refs.lectorVentaInput?.focus();
        this.toast.success(`Producto encontrado: ${producto.nombre}`);
      } else {
        this.productoEncontradoVenta = null;
        this.busquedaFallidaVenta = true;
        this.toast.error('Producto no encontrado');
      }
    },
    agregarProductoDesdeLector(producto) {
      if (this.productoYaAgregado(producto)) {
        this.toast.info('Producto ya está en la lista');
        return;
      }
      const precioUSD = producto.precio_venta_usd || 0;
      const costoUSD = producto.costo_unitario_usd || producto.precio_compra_usdt || 0;
      this.productosSeleccionados.push({
        idProducto: producto.idProducto,
        nombre: producto.nombre,
        codigo: producto.codigo,
        cantidad: 1,
        precio_original_usd: precioUSD,
        precio_unitario_usd: precioUSD,
        costo_unitario_usd: costoUSD,
        stock: producto.stock,
        subtotal: precioUSD,
        costo_total: costoUSD,
        garantia_meses: producto.garantia_meses || producto.garantiaMeses || 0,
        imagen: producto.imagen
      });
      this.calcularTotales();
      this.productoEncontradoVenta = null;
      this.codigoEscaneadoVenta = '';
      this.$refs.lectorVentaInput?.focus();
      this.toast.success(`${producto.nombre} agregado`);
    },
    formatearTipoDocumento(tipo) { const tipos = { 'cedula': 'Cédula', 'rif': 'RIF', 'pasaporte': 'Pasaporte', 'identificacion_extranjera': 'Identificación Extranjera' }; return tipos[tipo?.toLowerCase()] || tipo || 'Sin documento'; },
    getPlaceholderDocumento(tipo) { const placeholders = { 'cedula': 'V-31.757.818', 'rif': 'J-12345678-9', 'pasaporte': 'ABC123456', 'identificacion_extranjera': 'Número de identificación' }; return placeholders[tipo] || 'Número de documento'; },
    formatearDocumentoInput() { if (this.nuevoCliente.tipoDocumento && this.nuevoCliente.documento) this.nuevoCliente.documento = formatearDocumento(this.nuevoCliente.tipoDocumento, this.nuevoCliente.documento); },
    formatearTelefonoInput() { if (this.nuevoCliente.telefono) this.nuevoCliente.telefono = formatearTelefonoVenezolano(this.nuevoCliente.telefono); },
    calcularDescuentoBs() { if (this.tasaSeleccionada && this.form.descuento_usd > 0) this.form.descuento_bs = this.form.descuento_usd * this.tasaSeleccionada.precio_usd_bs; else this.form.descuento_bs = 0; },
    onMetodoPagoChange() { 
      this.puntoVenta = { referencia: '' };
      this.pagoMovil = { cedula: '', telefono: '', referencia: '', banco_origen: '' }; 
      this.transferencia = { referencia: '', banco_origen: '', banco_destino: '', numero_cuenta: '' }; 
    },
    autocompletarDatosBancoDestino() { },
    autocompletarDatosTransferencia() { const banco = this.bancosEmpresa.find(b => b.nombre === this.transferencia.banco_destino); if (banco) this.transferencia.numero_cuenta = banco.cuenta; else this.transferencia.numero_cuenta = ''; },
    async cargarDatosIniciales() { 
      try { 
        this.loading = true; 
        this.currentUser = getCurrentUser();
        if (this.currentUser) {
          this.form.idUsuario = this.currentUser.idUsuario || this.currentUser.id;
          const vendedorRes = await obtenerVendedorPorIdUsuario(this.form.idUsuario);
          if (vendedorRes.success && vendedorRes.data) {
            this.vendedorActual = vendedorRes.data;
            this.form.idVendedor = this.vendedorActual.idVendedor;
          } else {
            this.vendedorActual = {
              nombre: this.currentUser.nombre || 'Admin',
              apellido: this.currentUser.apellido || ''
            };
          }
        }

        const vendedoresRes = await obtenerVendedores(); 
        if (vendedoresRes.success) this.vendedores = vendedoresRes.data || []; 
        const productosRes = await obtenerProductos(); 
        if (productosRes.success) this.productosDisponibles = (productosRes.data || []).map(p => ({ 
          ...p, 
          precio_unitario_usd: p.precio_venta_usd || 0, 
          costo_unitario_usd: p.costo_unitario_usd || p.precio_compra_usdt || 0 
        })); 
        const tasasRes = await obtenerTasasVenta('activas'); 
        let tasasData = []; 
        if (tasasRes && tasasRes.success && Array.isArray(tasasRes.data)) tasasData = tasasRes.data; 
        else if (Array.isArray(tasasRes)) tasasData = tasasRes; 
        if (tasasData.length > 0) { 
          this.tasasVenta = tasasData; 
          const primeraTasa = tasasData[0]; 
          if (primeraTasa.idTasaVenta) { 
            this.form.idTasaVenta = primeraTasa.idTasaVenta.toString(); 
            this.tasaSeleccionada = { idTasaCambioVenta: primeraTasa.idTasaVenta, precio_usd_bs: primeraTasa.precio_usd_bs || 0, fuenteTasa: { nombre: primeraTasa.nombreFuente || 'Fuente' }, fecha: primeraTasa.fecha || new Date().toISOString(), idFuenteTasa: primeraTasa.idFuenteTasa, nombreFuente: primeraTasa.nombreFuente }; 
            this.form.tasa_bs_usd = this.tasaSeleccionada.precio_usd_bs; 
            this.form.idFuenteTasaVenta = this.tasaSeleccionada.idFuenteTasa; 
          } 
        } 
        const metodosRes = await obtenerMetodosPago(); 
        if (metodosRes.success) this.metodosPago = metodosRes.data || []; 
      } catch (error) { 
        console.error('Error:', error); 
        this.mostrarToastError('Error al cargar datos'); 
      } finally { 
        this.loading = false; 
      } 
    },
    async cargarTodosLosClientes() { try { const response = await obtenerClientes(); if (response.success) this.todosLosClientes = response.data || []; } catch (error) { console.error('Error:', error); } },
    actualizarTasaSeleccionada() { if (this.form.idTasaVenta && this.form.idTasaVenta !== '') { const idBuscado = Number(this.form.idTasaVenta); this.tasaSeleccionada = this.tasasVenta.find(t => Number(t.idTasaVenta) === idBuscado); if (this.tasaSeleccionada) { this.form.tasa_bs_usd = this.tasaSeleccionada.precio_usd_bs || 0; this.form.idFuenteTasaVenta = this.tasaSeleccionada.idFuenteTasa; this.calcularDescuentoBs(); this.calcularTotales(); } } else { this.tasaSeleccionada = null; } },
    debounceBuscarClientes() { this.mostrarListaClientes = true; if (this.timeoutBusqueda) clearTimeout(this.timeoutBusqueda); this.timeoutBusqueda = setTimeout(() => this.buscarClientesLocal(), 300); },
    mostrarClientesSiHay() { if (this.clientesEncontrados.length > 0) this.mostrarListaClientes = true; },
    buscarClientesLocal() { if (!this.buscarCliente || this.buscarCliente.trim() === '') { this.clientesEncontrados = []; this.mostrarListaClientes = false; return; } this.cargandoClientes = true; const termino = this.buscarCliente.toLowerCase().trim(); setTimeout(() => { this.clientesEncontrados = this.todosLosClientes.filter(cliente => { const nombreCompleto = `${cliente.nombre || ''} ${cliente.apellido || ''}`.toLowerCase(); const documento = (cliente.documento || '').toLowerCase(); const telefono = (cliente.telefono || '').toLowerCase(); const email = (cliente.email || '').toLowerCase(); return nombreCompleto.includes(termino) || documento.includes(termino) || telefono.includes(termino) || email.includes(termino); }).slice(0, 10); this.cargandoClientes = false; if (this.clientesEncontrados.length === 0 && termino.length >= 2) this.mostrarListaClientes = true; }, 300); },
    seleccionarCliente(cliente) { 
      this.clienteSeleccionado = { 
        ...cliente,
        idCliente: cliente.idCliente || cliente.id || cliente.id_cliente
      }; 
      this.form.idCliente = this.clienteSeleccionado.idCliente; 
      this.buscarCliente = ''; 
      this.clientesEncontrados = []; 
      this.mostrarListaClientes = false; 
      this.mostrarToastExito(`Cliente ${this.clienteSeleccionado.nombre} seleccionado`); 
    },
    deseleccionarCliente() { this.clienteSeleccionado = null; this.form.idCliente = null; this.buscarCliente = ''; this.clientesEncontrados = []; this.productosSeleccionados = []; this.calcularTotales(); this.mostrarToastInfo('Cliente removido'); },
    async guardarNuevoCliente() { if (!this.puedeGuardarCliente) { this.mostrarToastError('Complete los campos requeridos'); return; } try { this.guardandoCliente = true; const datosClienteOriginal = { ...this.nuevoCliente }; if (this.nuevoCliente.tipoDocumento && this.nuevoCliente.documento) this.nuevoCliente.documento = formatearDocumento(this.nuevoCliente.tipoDocumento, this.nuevoCliente.documento); if (this.nuevoCliente.telefono) this.nuevoCliente.telefono = formatearTelefonoVenezolano(this.nuevoCliente.telefono); const response = await crearCliente(this.nuevoCliente); if (response.success) { const clienteCreado = response.data; let clienteFormateado = { idCliente: clienteCreado.idCliente || clienteCreado.id, nombre: clienteCreado.nombre || datosClienteOriginal.nombre, apellido: clienteCreado.apellido || datosClienteOriginal.apellido || '', tipoDocumento: clienteCreado.tipoDocumento || datosClienteOriginal.tipoDocumento, documento: clienteCreado.documento || datosClienteOriginal.documento, telefono: clienteCreado.telefono || datosClienteOriginal.telefono || '', email: clienteCreado.email || datosClienteOriginal.email || '', direccion: clienteCreado.direccion || datosClienteOriginal.direccion || '' }; this.todosLosClientes.push(clienteFormateado); this.seleccionarCliente(clienteFormateado); this.nuevoCliente = { tipoDocumento: '', documento: '', nombre: '', apellido: '', telefono: '', email: '', direccion: '', estado: 'activo' }; this.modoCliente = 'buscar'; this.mostrarToastExito('Cliente creado'); } else throw new Error(response.error || 'Error'); } catch (error) { console.error('Error:', error); this.mostrarToastError('No se pudo crear el cliente'); } finally { this.guardandoCliente = false; } },
    mostrarModalProductos() { if (!this.clienteSeleccionado) { this.mostrarToastInfo('Debes seleccionar un cliente primero'); return; } this.showModalProductos = true; this.buscarProducto = ''; this.productosEncontrados = []; },
    cerrarModalProductos() { this.showModalProductos = false; this.buscarProducto = ''; this.productosEncontrados = []; },
    debounceBuscarProductos() { if (this.timeoutBusquedaProducto) clearTimeout(this.timeoutBusquedaProducto); this.timeoutBusquedaProducto = setTimeout(() => this.buscarProductosLocal(), 500); },
    buscarProductosLocal() { 
      if (!this.buscarProducto || this.buscarProducto.trim().length < 2) { this.productosEncontrados = []; return; } 
      this.cargandoProductos = true; 
      const normalize = (str) => (str || '').toString().toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "");
      const terms = normalize(this.buscarProducto).split(/\s+/).filter(Boolean);
      
      this.productosEncontrados = this.productosDisponibles.filter(p => {
        const searchableText = normalize(`${p.nombre} ${p.codigo} ${p.marca || ''} ${p.modelo || ''}`);
        return terms.every(term => searchableText.includes(term));
      });
      this.cargandoProductos = false; 
    },
    productoYaAgregado(producto) { return this.productosSeleccionados.some(p => p.idProducto === producto.idProducto); },
    agregarProducto(producto) { 
      if (this.productoYaAgregado(producto)) return; 
      const precioUSD = producto.precio_venta_usd || 0; 
      const costoUSD = producto.costo_unitario_usd || producto.precio_compra_usdt || 0; 
      this.productosSeleccionados.push({ 
        idProducto: producto.idProducto, 
        nombre: producto.nombre, 
        codigo: producto.codigo, 
        cantidad: 1, 
        precio_original_usd: precioUSD, 
        precio_unitario_usd: precioUSD, 
        costo_unitario_usd: costoUSD, 
        stock: producto.stock, 
        subtotal: precioUSD, 
        costo_total: costoUSD, 
        garantia_meses: producto.garantia_meses || producto.garantiaMeses || 0, 
        imagen: producto.imagen 
      }); 
      this.calcularTotales(); 
      this.mostrarToastExito(`${producto.nombre} agregado`); 
    },
    removerProducto(index) { const producto = this.productosSeleccionados[index]; this.productosSeleccionados.splice(index, 1); this.calcularTotales(); this.mostrarToastInfo(`${producto.nombre} removido`); },
    actualizarSubtotalProducto(producto) { 
      if (producto.cantidad < 1) producto.cantidad = 1; 
      producto.subtotal = (producto.cantidad || 1) * (producto.precio_unitario_usd || 0); 
      producto.costo_total = (producto.cantidad || 1) * (producto.costo_unitario_usd || 0); 
      this.calcularTotales(); 
    },
    
    calcularTotales() { 
      this.subtotal = this.productosSeleccionados.reduce((total, producto) => total + (producto.subtotal || 0), 0); 
      const descuento = parseFloat(this.form.descuento_usd) || 0; 
      
      this.baseImponible = Math.max(0, this.subtotal - descuento);
      
      if (this.form.aplicar_iva) {
        const pct = parseFloat(this.form.iva_porcentaje) || 0;
        this.ivaMonto = Number(((this.baseImponible * pct) / 100).toFixed(2));
      } else {
        this.ivaMonto = 0;
      }
      
      this.total = Number((this.baseImponible + this.ivaMonto).toFixed(2));
      
      if (this.tasaSeleccionada) {
        this.ivaMontoBs = Number((this.ivaMonto * this.tasaSeleccionada.precio_usd_bs).toFixed(2));
      } else {
        this.ivaMontoBs = 0;
      }
    },
    
    prepararObservaciones() { 
      const lineas = []; 
      lineas.push(`Tipo: CONTADO`); 
      lineas.push(`Factura: ${this.form.numero_factura}`); 
      lineas.push(`Subtotal: $${this.subtotal.toFixed(2)}`); 
      if (this.form.descuento_usd > 0) lineas.push(`Descuento: -$${this.form.descuento_usd.toFixed(2)}`); 
      if (this.form.aplicar_iva && this.ivaMonto > 0) {
        lineas.push(`Base Imponible: $${this.baseImponible.toFixed(2)}`);
        lineas.push(`IVA ${this.form.iva_porcentaje}%: $${this.ivaMonto.toFixed(2)}`);
      }
      // ✅ Solo agregar al texto si el usuario puede ver ganancia
      if (this.puedeVerGanancia) {
        lineas.push(`Costo Total: $${this.costoTotalProductos.toFixed(2)}`);
        lineas.push(`Ganancia: $${this.gananciaEstimada.toFixed(2)}`);
      }
      lineas.push(`Total: $${this.total.toFixed(2)}`); 
      if (this.clienteSeleccionado) { 
        lineas.push(`Cliente: ${this.clienteSeleccionado.nombre} ${this.clienteSeleccionado.apellido}`); 
        lineas.push(`Documento: ${this.formatearTipoDocumento(this.clienteSeleccionado.tipoDocumento)}: ${this.clienteSeleccionado.documento}`); 
        if (this.clienteSeleccionado.telefono) lineas.push(`Teléfono: ${this.clienteSeleccionado.telefono}`); 
        if (this.clienteSeleccionado.email) lineas.push(`Email: ${this.clienteSeleccionado.email}`); 
      } 
      const vendedor = this.vendedores.find(v => v.idVendedor == this.form.idVendedor); 
      if (vendedor) lineas.push(`Vendedor: ${vendedor.nombre} ${vendedor.apellido}`); 
      if (this.tasaSeleccionada) lineas.push(`Tasa: ${this.tasaSeleccionada.nombreFuente} - Bs. ${this.tasaSeleccionada.precio_usd_bs.toFixed(2)}`); 
      if (this.productosSeleccionados.length > 0) { 
        lineas.push('Productos:'); 
        this.productosSeleccionados.forEach((p, i) => { 
          lineas.push(`  ${i + 1}. ${p.nombre} (${p.cantidad} x $${p.precio_unitario_usd.toFixed(2)} = $${p.subtotal.toFixed(2)})`); 
        }); 
      } 
      if (this.form.idMetodoPago) { 
        const metodo = this.metodosPago.find(m => m.idMetodoPago == this.form.idMetodoPago); 
        lineas.push(`Método de Pago: ${metodo?.nombre || 'EFECTIVO'}`); 
        lineas.push(`Monto pagado: $${this.total.toFixed(2)}`); 
        if (this.esPuntoVenta) lineas.push(`Punto de Venta - Referencia: ${this.puntoVenta.referencia}`);
        if (this.esPagoMovil) lineas.push(`Pago Móvil - Banco Origen: ${this.pagoMovil.banco_origen}`);
        if (this.esTransferencia) lineas.push(`Transferencia - Ref: ${this.transferencia.referencia}`);
      } 
      return lineas.join('\n'); 
    },
    
    async crearVenta() { 
      if (!this.puedeCrearVenta) { 
        this.mostrarToastError('Complete todos los campos requeridos'); 
        return; 
      } 
      try { 
        this.guardando = true; 
        
        // ✅ SIEMPRE se calcula, aunque no se muestre (para el backend)
        const costoTotalUsd = this.costoTotalProductos;
        const gananciaNetaUsd = this.total - costoTotalUsd;
        const margenGanancia = costoTotalUsd > 0 ? (gananciaNetaUsd / costoTotalUsd) * 100 : 0;
        
        const detalles = this.productosSeleccionados.map(p => {
          const costoUnit = parseFloat(p.costo_unitario_usd || 0);
          const costoTotal = parseFloat(p.costo_total || 0);
          const precioUnit = parseFloat(p.precio_unitario_usd || 0);
          const subtotalDet = parseFloat(p.subtotal || 0);
          const gananciaUnit = precioUnit - costoUnit;
          const gananciaTotal = subtotalDet - costoTotal;
          const margen = precioUnit > 0 ? ((gananciaUnit / precioUnit) * 100) : 0;
          
          return {
            idProducto: parseInt(p.idProducto),
            cantidad: parseInt(p.cantidad),
            precioUnitarioUsd: precioUnit,
            subtotalUsd: subtotalDet,
            precioUnitarioBs: precioUnit * (this.tasaSeleccionada?.precio_usd_bs || 0),
            subtotalBs: subtotalDet * (this.tasaSeleccionada?.precio_usd_bs || 0),
            costoUnitarioUsd: costoUnit,
            costoTotalUsd: costoTotal,
            gananciaUnitarioUsd: gananciaUnit,
            gananciaTotalUsd: gananciaTotal,
            margenGananciaPorcentaje: margen,
            garantiaMeses: parseInt(p.garantia_meses || 0),
            garantiaDias: 0,
            tieneGarantia: (p.garantia_meses > 0)
          };
        }); 
        
        const observacionesExtras = this.prepararObservaciones(); 
        
        const ventaData = { 
          numeroFactura: this.form.numero_factura, 
          fechaVenta: new Date().toISOString(), 
          tipoVenta: this.form.tipo_venta.toLowerCase(), 
          subtotalUsd: this.baseImponible,
          ivaUsd: this.ivaMonto,
          descuentoUsd: parseFloat(this.form.descuento_usd) || 0, 
          totalUsd: this.total,
          subtotalBs: this.baseImponible * this.tasaSeleccionada.precio_usd_bs,
          ivaBs: this.ivaMontoBs,
          descuentoBs: (parseFloat(this.form.descuento_usd) || 0) * this.tasaSeleccionada.precio_usd_bs, 
          totalBs: this.total * this.tasaSeleccionada.precio_usd_bs,
          // ✅ SIEMPRE se envía, aunque el vendedor no lo vea
          costoTotalUsd: costoTotalUsd, 
          gananciaNetaUsd: gananciaNetaUsd, 
          margenGananciaPorcentaje: margenGanancia, 
          tasaBsUsd: this.tasaSeleccionada.precio_usd_bs, 
          idFuenteTasaVenta: this.tasaSeleccionada.idFuenteTasa, 
          idTasaVenta: parseInt(this.form.idTasaVenta), 
          idVendedor: parseInt(this.form.idVendedor), 
          estado: 'completada', 
          observaciones: observacionesExtras, 
          idCliente: this.form.idCliente || (this.clienteSeleccionado ? (this.clienteSeleccionado.idCliente || this.clienteSeleccionado.id) : null), 
          detalles: detalles 
        }; 
        
        const response = await crearVenta(ventaData); 
        if (response.success) { 
          const ventaCreada = response.data; 
          let referencia = ''; 
          if (this.esPuntoVenta) referencia = this.referenciaPuntoVenta || `PV-${Date.now()}`;
          else if (this.esPagoMovil) referencia = this.pagoMovil.referencia || `PM-${Date.now()}`;
          else if (this.esTransferencia) referencia = this.transferencia.referencia || `TR-${Date.now()}`;
          else referencia = `EFE-${Date.now()}`;
          
          const montoAPagar = this.total;
          
          if (montoAPagar > 0) {
            const pagoPayload = { 
              idVenta: ventaCreada.idVenta, 
              montoUsd: montoAPagar, 
              montoBs: montoAPagar * this.tasaSeleccionada.precio_usd_bs, 
              fechaPago: new Date().toISOString(), 
              tipoPago: this.esPuntoVenta ? 'punto_venta' : (this.esPagoMovil ? 'pago_movil' : (this.esTransferencia ? 'transferencia' : 'efectivo')), 
              numeroRecibo: referencia, 
              observaciones: `Pago de venta - Factura: ${this.form.numero_factura}` 
            }; 
            try { 
              await registrarPagoVenta(pagoPayload); 
            } catch (pagoError) { 
              console.error('Error registrando pago:', pagoError); 
            }
          } 
          
          const productosFactura = this.productosSeleccionados.map(p => ({ 
            nombre: p.nombre, 
            codigo: p.codigo, 
            cantidad: p.cantidad, 
            precio: p.precio_unitario_usd,
            garantiaMeses: p.garantia_meses || p.garantiaMeses || 0
          })); 
          
          const ventaFactura = { 
            numeroFactura: this.form.numero_factura, 
            subtotal: this.baseImponible,
            descuentoUSD: this.form.descuento_usd, 
            ivaUSD: this.ivaMonto,
            ivaPorcentaje: this.form.aplicar_iva ? this.form.iva_porcentaje : 0,
            total: this.total,
            metodoPago: this.metodosPago.find(m => m.idMetodoPago == this.form.idMetodoPago)?.nombre || 'EFECTIVO', 
            tipoVenta: this.form.tipo_venta,
            montoInicial: this.total
          }; 
          
          const vendedor = this.vendedores.find(v => v.idVendedor == this.form.idVendedor); 
          setTimeout(() => { 
            imprimirFactura(ventaFactura, this.clienteSeleccionado, vendedor || { nombre: 'VENDEDOR' }, this.tasaSeleccionada, productosFactura); 
          }, 500); 
          
          // ✅ Mensaje al usuario (sin ganancia si no tiene permisos)
          const mensajeExito = this.puedeVerGanancia
            ? `Factura: ${this.form.numero_factura}<br>Total: $${this.total.toFixed(2)}<br><span style="color:#059669">Ganancia: $${gananciaNetaUsd.toFixed(2)}</span>${this.form.aplicar_iva ? `<br><span style="color:#059669">IVA ${this.form.iva_porcentaje}%: $${this.ivaMonto.toFixed(2)}</span>` : ''}`
            : `Factura: ${this.form.numero_factura}<br>Total: $${this.total.toFixed(2)}${this.form.aplicar_iva ? `<br><span style="color:#059669">IVA ${this.form.iva_porcentaje}%: $${this.ivaMonto.toFixed(2)}</span>` : ''}`;
          
          this.mostrarConfirmacion({ 
            title: '¡Venta creada exitosamente!', 
            message: mensajeExito, 
            icon: 'mdi:check-circle', 
            type: 'success', 
            confirmText: 'Ver ventas', 
            cancelText: 'Permanecer', 
            onConfirm: () => this.$router.push('/ventas') 
          });
          notificarVenta('Venta creada', `Factura ${this.form.numero_factura}`, `Total: $${this.total.toFixed(2)}`);
        } else throw new Error(response.error || 'Error'); 
      } catch (error) { 
        console.error('Error:', error); 
        this.mostrarToastError(error.message || 'No se pudo crear la venta'); 
      } finally { 
        this.guardando = false; 
      } 
    },
    
    volverAListado() { if (this.clienteSeleccionado || this.productosSeleccionados.length > 0) { this.mostrarConfirmacion({ title: '¿Salir sin guardar?', message: 'Hay información sin guardar. ¿Estás seguro?', icon: 'mdi:alert', iconClass: 'bg-yellow-100 dark:bg-yellow-900/30', iconColor: 'text-yellow-600 dark:text-yellow-400', type: 'warning', confirmText: 'Sí, salir', cancelText: 'Cancelar', onConfirm: () => this.$router.push('/ventas') }); } else { this.$router.push('/ventas'); } }
  }
};
</script>

<style scoped>
.text-lexend { font-family: 'Lexend', sans-serif; }
@keyframes zoomIn { from { opacity: 0; transform: scale(0.95); } to { opacity: 1; transform: scale(1); } }
.animate-zoomIn { animation: zoomIn 0.2s ease-out; }
.animate-fadeIn { animation: fadeIn 0.3s ease-out; }
@keyframes fadeIn { from { opacity: 0; } to { opacity: 1; } }
.custom-scrollbar::-webkit-scrollbar { width: 6px; }
.custom-scrollbar::-webkit-scrollbar-track { background: transparent; }
.custom-scrollbar::-webkit-scrollbar-thumb { background: #e2e8f0; border-radius: 10px; }
.dark .custom-scrollbar::-webkit-scrollbar-thumb { background: #334155; }
</style>